<template>
  <div class="project-manage">
    <!-- 选择广告主账号 -->
    <el-card class="filter-card">
      <label>广告主账号：</label>
      <el-select
        v-model="advertiser_ids.value"
        size="mini"
        placeholder="请选择广告主账号"
        multiple
        collapse-tags
        filterable
      >
        <el-option
          v-for="(item, index) in advertiser_ids.options"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <el-button
        :loading="pull_loading"
        style="margin-left: 10px"
        size="mini"
        type="primary"
        @click="pullProjectList"
      >同步项目</el-button>

      <el-button
        class="fr"
        size="mini"
        type="primary"
        @click="project_config.is_show = true"
      >创建项目</el-button>
      <el-button
        class="fr"
        size="mini"
        type="success"
        @click="toIntelligenceCreate"
      >智能创建</el-button>
    </el-card>

    <!-- 筛选查询 -->
    <el-card class="filter-card">
      <app-filter
        default-label-width="120px"
        :filter-list="table_filter"
        @search="searchTable"
      />
    </el-card>

    <!-- 项目列表 -->
    <el-card class="box-card">
      <!-- 批量操作 -->
      <div class="func-box" style="padding: 20px 0">
        <label>批量操作：</label>
        <el-select
          v-model="batch_operate_config.value"
          size="mini"
          placeholder="选择需要批量的操作"
          clearable
        >
          <el-option
            v-for="(item, index) in batch_operate_config.options"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="warning"
          size="mini"
          plain
          @click="batchExecute"
        >执行</el-button>
      </div>

      <app-table
        ref="project_table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getProjectList"
        :check="true"
        @select-tr="tableCheckTr"
      />
    </el-card>

    <el-drawer
      :title="project_config.title"
      :visible.sync="project_config.is_show"
      :before-close="projectCancel"
      size="900px"
    >
      <project-create
        v-if="project_config.is_show"
        :project-data="project_config.data"
        @cancel="projectCancel"
        @confirm="projectConfirm"
      />
    </el-drawer>
  </div>
</template>

<script>
import { getProjectListApi, pullProjectListApi, batchDeleteProjectApi } from '@/api/project/jrtt';
import { getMediasListApi } from '@/api/medias';
import getJrttProjectConfig from '@/tools/form/model/jrtt/project-config';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'project-create': () => import('./components/project-create'),
  },
  data() {
    return {
      table_filter: require('./model/table-filter')(this),
      table_key: require('./model/table-key')(this),
      /** 同步加载 */
      pull_loading: false,
      /** 表格请求参数 */
      table_params: {
        page: 1,
        limit: 10,
      },
      /** 表格勾选列表 */
      table_check_list: [],
      /** 广告主账号筛选框 */
      advertiser_ids: {
        options: [],
        value: [],
      },

      /** 批量操作配置 */
      batch_operate_config: {
        options: [
          {
            label: '删除',
            value: 'delete',
          },
        ],
        value: '',
      },

      // 表格数据
      table_list_data: {
        list: [{
          id: 1,
        }],
      },

      /**
       * 项目配置
       */
      project_config: {
        is_show: false,
        title: '创建项目',
        data: null,
      },
      /** 项目表单配置 */
      project_form_config: {
        target_form: {
          config: getJrttProjectConfig(['download_type', 'download_mode', 'launch_type']),
        },
        // 项目状态
        status_form: {
          config: {
            status: {
              // 目前只有列表用到，所以暂时写在代码里，后续如果多处复用再统一放在枚举值管理中
              enumVal: {
                'PROJECT_STATUS_NO_SCHEDULE': '不在投放时段',
                'PROJECT_STATUS_DONE': '已完成',
                'PROJECT_STATUS_NOT_START': '未达投放时间',
                'PROJECT_STATUS_BUDGET_PRE_OFFLINE_BUDGET': '项目接近预算',
                'PROJECT_STATUS_BUDGET_EXCEED': '项目超出预算',
                'PROJECT_STATUS_NOT_DELETE': '所有不包含已删除',
                'PROJECT_STATUS_ALL': '所有包含已删除',
                'PROJECT_STATUS_DELETE': '删除',
                'PROJECT_STATUS_DISABLE': '暂停',
                'PROJECT_STATUS_ENABLE': '启用',
              },
            },
          },
        },
      },
    };
  },
  created() {
    this.getMediasList();
    this.genProjectEnumVal();
  },
  methods: {
    /** 生成项目表单配置数据枚举值 */
    genProjectEnumVal() {
      Object.entries(this.project_form_config.target_form.config).forEach(([key, value]) => {
        value.enumVal = value.options.reduce((target, currentValue) => {
          return {
            ...target,
            [currentValue.value]: key === 'download_mode' ? (currentValue.value === 'DEFAULT' ? '默认下载' : '优先商店下载') : currentValue.label,
          };
        }, {});
      });
    },
    /**
     * 查询表格
     * @param {Object} params_value
     */
    searchTable(params_value) {
      const { create_time, update_time } = params_value;
      if (create_time?.length) {
        params_value['start_created_time'] = create_time[0];
        params_value['end_created_time'] = create_time[1];
        delete params_value.create_time;
      } else {
        params_value.start_created_time = null;
        params_value.end_created_time = null;
      }

      if (update_time?.length) {
        params_value.start_updated_time = update_time[0];
        params_value.end_updated_time = update_time[1];
        delete params_value.update_time;
      } else {
        params_value.start_updated_time = null;
        params_value.end_updated_time = null;
      }

      this.table_params = {
        ...this.table_params,
        ...params_value,
        advertiser_ids: this.advertiser_ids.value,
      };

      this.$nextTick(() => {
        this.$refs.project_table.seekTable();
      });
    },

    /**
     * 表格勾选行事件
     */
    tableCheckTr(list) {
      this.table_check_list = list;
    },

    /**
     * 批量执行
     */
    batchExecute() {
      const { value } = this.batch_operate_config;
      // 判断是否选中批量操作
      if (!value) {
        this.$message.warning('请选择需要批量执行的操作');
        return;
      }

      // 判断是否选中操作的数据
      if (!this.table_check_list.length) {
        this.$message.warning('请选中需要操作的数据');
        return;
      }

      switch (value) {
        case 'delete':
          this.$confirm('确认要删除吗？').then(_ => {
            batchDeleteProjectApi({
              source_ids: this.table_check_list.map(item => item.id),
            }).then(res => {
              this.$message.success(res.message);
              this.$nextTick(() => {
                this.$refs.project_table.seekTable();
              });
            });
          }).catch(() => {});
          break;
        default:
          break;
      }
    },

    /**
     * 修改项目
     * @param { Object } row 行数据
     */
    editProject(row) {
      this.project_config.is_show = true;
      this.project_config.data = row;
      this.project_config.title = '编辑项目';
    },

    /**
     * 项目表单取消
     */
    projectCancel() {
      if (this.project_config.data) {
        this.project_config.data = null;
        this.project_config.title = '创建项目';
      }

      this.project_config.is_show = false;
    },

    /**
     * 项目表单确定
     */
    projectConfirm() {
      this.projectCancel();

      this.$refs.project_table.seekTable();
    },

    /** 获取项目列表 */
    getProjectList: getProjectListApi,

    /** 同步项目列表 */
    async pullProjectList() {
      this.pull_loading = true;
      try {
        const pull_messages = [];
        for (let i = 0; i < this.advertiser_ids.value.length; i++) {
          const id = this.advertiser_ids.value[i];
          const item = await pullProjectListApi({ advertiser_id: id });
          pull_messages.push(id + '=>' + item.message + '</br>');
        }

        // 显示同步结果
        if (pull_messages.length) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'success',
            message: `
              <h2>同步结果： </h2></br>
              ${pull_messages.join('')}
            `,
          });
        } else {
          this.$message.warning('请选择广告主账号！');
        }

        this.pull_loading = false;
      } catch (error) {
        this.pull_loading = false;
      }
    },

    /** 获取广告账号列表 */
    getMediasList() {
      return getMediasListApi({
        type: 'jrtt',
        is_list: true,
      }).then((res) => {
        this.advertiser_ids.options = res.list.map((accoun_item) => {
          return {
            label: `${accoun_item.advertiser_id}(${accoun_item.advertiser_name})${accoun_item.note ? ' - ' + accoun_item.note : ''}`,
            value: accoun_item.advertiser_id,
          };
        });
      });
    },
    /** 跳转到智能创建 */
    toIntelligenceCreate() {
      this.$router.push('/superior/superior-jrtt/intelligence-create-plan');
    },
  },
};
</script>

<style lang="scss" scoped>
.project-manage {
  .func-box {
    .el-button {
      margin-left: 10px;
    }
  }
  .el-card {
      margin-bottom: 20px;
  }
}

</style>
